import { render, staticRenderFns } from "./Bricks.vue?vue&type=template&id=b696a372"
import script from "./Bricks.vue?vue&type=script&lang=js"
export * from "./Bricks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports